import { CONSTANTS } from "@pushprotocol/restapi";

const configs = {
  local: {
    apiUrl: "http://localhost:21667",
    socketIOUrl: "http://localhost:21667",
    portalUrl: "http://localhost:3000",
    widgetUrl: "https://dev.widget.metacrm.inc/static/js/",
    websiteOptInUrl: "https://dev.optin.metacrm.inc/",
    trackingUrl: "https://dev.attribution.metacrm.inc/",
    adamUrl: "http://localhost:8000",
    sessionNumOfHours: 24,
    allowedEntities: {
      billing: ["jeff"],
      ecoScan: ["yungtestworkspace3", "ethan", "jeff", "demosite"],
    },
    xmtpEnv: "dev",
    pushEnv: CONSTANTS.ENV.STAGING,
  },
  dev: {
    apiUrl: "https://api-dev.metacrm.inc",
    socketIOUrl: "https://api-dev.metacrm.inc",
    portalUrl: "https://dev.metacrm.inc",
    widgetUrl: "https://dev.widget.metacrm.inc/static/js/",
    websiteOptInUrl: "https://dev.optin.metacrm.inc/",
    trackingUrl: "https://dev.attribution.metacrm.inc/",
    adamUrl: "https://api.ai.metacrm.inc",
    sessionNumOfHours: 24,
    allowedEntities: {
      billing: ["standard"],
      ecoScan: ["morphdev"],
    },
    xmtpEnv: "dev",
    pushEnv: CONSTANTS.ENV.STAGING,
  },

  demo: {
    apiUrl: "https://api-demo.metacrm.inc",
    socketIOUrl: "https://api-demo.metacrm.inc",
    portalUrl: "https://beta.metacrm.inc",
    widgetUrl: "https://beta.widget.metacrm.inc/static/js/",
    websiteOptInUrl: "https://beta.optin.metacrm.inc/",
    trackingUrl: "https://beta.attribution.metacrm.inc/",
    adamUrl: "https://api.ai.metacrm.inc",
    sessionNumOfHours: 24,
    allowedEntities: {
      billing: [],
      ecoScan: ["demoJustin3"],
    },
    xmtpEnv: "dev",
    pushEnv: CONSTANTS.ENV.STAGING,
  },
  production: {
    apiUrl: "https://api-desk.metacrm.inc",
    socketIOUrl: "https://api-desk.metacrm.inc",
    portalUrl: "https://app.metacrm.inc",
    widgetUrl: "https://widget.metacrm.inc/static/js/",
    websiteOptInUrl: "https://optin.metacrm.inc/",
    trackingUrl: "https://attribution.metacrm.inc/",
    adamUrl: "https://api.ai.metacrm.inc",
    sessionNumOfHours: 1,
    allowedEntities: {
      billing: ["metacrm"],
      ecoScan: ["morphl2"],
    },
    xmtpEnv: "production",
    pushEnv: CONSTANTS.ENV.PROD,
  },
};

const environment = process.env.REACT_APP_ENV || "local";

export default configs[environment];
